import {mergeDeep} from "../../../utils/Helper";
import {validations} from "./CounterParty";

export const defaultState = () => ({
  custodianEntityId: 0,
  counterparty: {
    CounterPartyId: 0,
    CounterPartyName: "",
    CounterPartyLimit: 0,
    CounterPartyStatus: "",
    CounterPartyEmail: "",
    CustodianEntityId: 0,
    custodianEntity: []
  },
  fields: {
    readonly: {},
    errors: {}
  },
  buttons: {
    confirm: {
      loading: false
    }
  },
  clearinghouse: {
    code: 0,
    name: "",
    clearinghouse: 0,
    settlementins: "",
    default: false
  },
  clearingHouses: [],
  editClearingHouse: false,
  editClearingHouseId: false,
  saveEditClearingHouseId: 0,
  saveEditClearingHouseCode: 0,
  conf: false,
  errors: {
    title: false,
    limit: false,
    code: false,
    name: false,
    clearinghouse: false,
    settlementins: false
  },
  sentAuthorization: false,
  message: "",
  entities: []
});

export const CounterPartySimpleReducer = (state, action) => {
  switch (action.type) {
    case "CHANGE_FIELDS":
      return processChangeFields(state, action.fields);
    case "UPDATE_FIELDS":
      return processFields(state, action.fields);
    case "CLEARING_HOUSES_FIELDS":
      return processChangeClearingHousesFields(state, action.fields);
    case "ADD_CLEARING_HOUSE":
      return AddClearingHouses(state, action);
    case "EDIT_CLEARING_HOUSE":
      return editClearingHouse(state, action);
    case "CLOSE_CLEARING_HOUSE":
      return closeClearingHouse(state);
    case "DEFAULT_CLEARING_HOUSE":
      return DefaultClearingHouses(state, action.fields);
    case "EDIT_CLEARING_HOUSE_ID":
      return EditClearingHouseId(state, action);
    case "UPDATE_BUTTONS":
      return processUpdateButtons(state, action.buttons);
    case "FORCE_UPDATE_VALIDATION":
      return forceUpdateValidation(state, action);
    case "SAVE_EDIT_CLEARING_HOUSE":
      return SaveEditClearingHouse(state, action);
    case "CONFIRM_COUNTER_PARTY":
      return ConfirmCounterParty(state);
    case "SENT_AUTHORIZATION":
      return SentAuthorization(state, action);
    case "RESET_CLOSE":
      return ResetClose(state, action);
    case "LOADING_COUNTER_PARTY":
      return LoadingCounterParty(state, action);
    case "GET_CUSTODIAN_ENTITY":
      return GetCustodianEntity(state, action);
    case "OPEN_CUSTODIAN_ENTITY":
      return OpenCustodianEntity(state, action);
    case "EDIT_CUSTODIAN_ENTITY":
      return EditCustodianEntity(state, action);
    case "CLOSE_CUSTODIAN_ENTITY":
      return CloseCustodianEntity(state, action);
    case "RECHARGE_CUSTODIAN_ENTITY":
      return RechargeCustodianEntity(state, action);
    case "CUSTODIAN_ENTITY_ID":
      return DefineCustodianEntityId(state, action);
    case "SET_COUNTER_PARTY":
      return SetCounterParty(state, action);
    case "SENT_AUTHORIZATION_UPDATE":
      return SentAuthorizationUpdate(state, action);
    case "SET_ERRORS_COUNTER_PARTY":
      return SetErrorsCounterParty(state, action);
    default:
      return state;
  }
};

export function LoadingCounterParty(state, {errors}) {
  return mergeDeep(
    {...state},
    {
      buttons: {
        confirm: {
          loading: true
        }
      }
    }
  );
}

function processFields(state, fields) {
  return mergeDeep(
    {...state},
    {
      ...fields
    }
  );
}

function SetErrorsCounterParty(state, fields) {
  return {...state, errors: fields.errors}
}

function processChangeFields(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    f[name] = undefined;
    return f;
  }, {});

  return mergeDeep(
    {...state},
    {
      counterparty: {
        ...fields
      },
      fields: {
        errors
      }
    }
  );
}

function DefaultClearingHouses(state, fields) {
  var bool = false;
  if (fields == "Yes") {
    bool = true;
  }
  return mergeDeep(
    {...state},
    {
      clearinghouse: {
        default: bool
      }
    }
  );
}

function EditClearingHouseId(state, c) {
  var clear = {
    code: 0,
    name: "",
    clearinghouse: 0,
    settlementins: "",
    default: false
  };
  for (var i = 0; i < state.clearingHouses.length; i++) {
    if (
      state.clearingHouses[i].clearingHouseId == c.c.clearingHouseId &&
      state.clearingHouses[i].clearingHouseCode == c.c.clearingHouseCode
    ) {
      clear = {
        code: state.clearingHouses[i].clearingHouseCode,
        name: state.clearingHouses[i].name,
        clearinghouse: state.clearingHouses[i].clearingHouseId,
        settlementins:
          state.clearingHouses[i].clearingHouseSettlementInstructions,
        default: state.clearingHouses[i].clearingHouseDefault
      };
    }
  }
  return mergeDeep(
    {...state},
    {
      editClearingHouseId: true,
      clearinghouse: clear,
      saveEditClearingHouseId: c.c.clearingHouseId,
      saveEditClearingHouseCode: c.c.clearingHouseCode
    }
  );
}

function processChangeClearingHousesFields(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    f[name] = undefined;
    return f;
  }, {});

  return mergeDeep(
    {...state},
    {
      clearinghouse: {
        ...fields
      },
      fields: {
        errors
      }
    }
  );
}

export function validateForm(state) {
  const {counterparty, fields, clearinghouse} = state;

  const errors = {};

  Object.entries(validations(counterparty)).forEach(entry => {
    const [name, value] = entry;

    if (!fields.readonly[name]) {
      if (value.empty) {
        if (counterparty[name] == undefined || counterparty[name] === "") {
          errors[name] = "Required field";
        } else if (
          value.autosuggestId &&
          (counterparty[value.autosuggestId] == undefined || counterparty[value.autosuggestId] == 0)
        ) {
          errors[name] = "Must select a value from list";
        }
      }
    }
  });

  // has Errors only add errors to state
  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
}

export function forceUpdateValidation(state, {errors}) {
  return {
    ...state,
    fields: {
      ...state.fields,
      errors
    }
  };
}

export function processUpdateButtons(state, buttons) {
  return mergeDeep(
    {...state},
    {
      buttons
    }
  );
}

export const initialize = props => {
  return initialState => {
    return {
      counterparty: {
        CounterPartyId: 0,
        CounterPartyName: "",
        CounterPartyLimit: 0,
        CounterPartyStatus: "",
        CounterPartyEmail: "",
        CustodianEntityId: 0
      },
      fields: {
        readonly: {},
        errors: {}
      },
      buttons: {
        confirm: {
          loading: false
        }
      },
      clearinghouse: {
        code: 0,
        name: "",
        clearinghouse: 0,
        settlementins: "",
        default: false
      },
      clearingHouses: [],
      editClearingHouse: false,
      editClearingHouseId: false,
      saveEditClearingHouseId: 0,
      saveEditClearingHouseCode: 0,
      conf: false,
      errors: {
        title: false,
        limit: false,
        code: false,
        name: false,
        clearinghouse: false,
        settlementins: false
      },
      sentAuthorization: false,
      message: "",
      custodianEntity: [],
      custodianEntityId: 0,
      isEditCustodianEntity: false,
      openCustodianEntity: false
    };
  };
};

export function AddClearingHouses(state, action) {
  const {
    counterparty,
    fields,
    clearinghouse,
    clearingHouses,
    editClearingHouse
  } = state;
  var name = "";
  var totalerror = true;
  var edit = false;
  var error = {
    title: false,
    limit: false,
    code: false,
    name: false,
    clearinghouse: false,
    settlementins: false
  };
  if (clearinghouse.code == 0) {
    error.code = true;
    edit = true;
    totalerror = false;
  }
  if (clearinghouse.settlementins == "") {
    (error.settlementins = true), (edit = true), (totalerror = false);
  }
  if (edit) {
    return mergeDeep(
      {...state},
      {
        editClearingHouse: edit,
        editClearingHouseId: edit,
        errors: error
      }
    );
  } else {
    for (var j = 0; j < action.clearinghouses.length; j++) {
      if (action.clearinghouses[j].id == clearinghouse.clearinghouse) {
        name = action.clearinghouses[j].name;
      }
    }
    return mergeDeep(
      {...state},
      {
        clearingHouses: [
          ...state.clearingHouses,
          {
            clearingHouseId: clearinghouse.clearinghouse,
            clearingHouseCode: clearinghouse.code,
            clearingHouseSettlementInstructions: clearinghouse.settlementins,
            clearingHouseDefault: clearinghouse.default,
            name: name
          }
        ],
        editClearingHouse: edit,
        editClearingHouseId: edit,
        errors: error
      }
    );
  }
}

export function SaveEditClearingHouse(state, action) {
  const {
    counterparty,
    fields,
    clearinghouse,
    saveEditClearingHouseId,
    saveEditClearingHouseCode,
    errors
  } = state;
  var totalerror = true;
  var edit = false;
  var error = {
    title: false,
    limit: false,
    code: false,
    name: false,
    clearinghouse: false,
    settlementins: false
  };
  if (clearinghouse.code == 0) {
    error.code = true;
    edit = true;
    totalerror = false;
  }
  if (clearinghouse.settlementins == "") {
    (error.settlementins = true), (edit = true), (totalerror = false);
  }
  var name = "";
  var clearing = state.clearingHouses;
  for (var i = 0; i < clearing.length; i++) {
    if (
      clearing[i].clearingHouseId == saveEditClearingHouseId &&
      clearing[i].clearingHouseCode == saveEditClearingHouseCode
    ) {
      for (var j = 0; j < action.clearinghouses.length; j++) {
        if (action.clearinghouses[j].id == clearinghouse.clearinghouse) {
          name = action.clearinghouses[j].name;
        }
      }
      clearing[i] = {
        clearingHouseCode: clearinghouse.code,
        name: name,
        clearingHouseId: clearinghouse.clearinghouse,
        clearingHouseSettlementInstructions: clearinghouse.settlementins,
        clearingHouseDefault: clearinghouse.default
      };
    }
  }
  return mergeDeep(
    {...state},
    {
      errors: error,
      clearingHouses: clearing,
      editClearingHouse: edit,
      editClearingHouseId: edit,
      saveEditClearingHouseId: 0,
      saveEditClearingHouseCode: 0,
      conf: totalerror
    }
  );
}

export function ConfirmCounterParty(state) {
  const {conf, counterparty, errors} = state;
  var totalerror = true;
  var error = {
    title: false,
    limit: false,
    code: false,
    name: false,
    clearinghouse: false,
    settlementins: false
  };
  if (counterparty.limit == 0) {
    error.limit = true;
    totalerror = false;
  }
  if (counterparty.title == "") {
    (error.title = true), (totalerror = false);
  }
  var button = {
    confirm: {
      loading: totalerror
    }
  };
  return mergeDeep(
    {...state},
    {
      errors: error,
      conf: totalerror
      // buttons:button
    }
  );
}

export function editClearingHouse(state, props) {
  const {editClearingHouse, counterparty} = state;
  return mergeDeep(
    {...state},
    {
      editClearingHouse: true,
      editClearingHouseId: false,
      clearinghouse: {
        code: 0,
        name: props.clearinghouses[0].name,
        clearinghouse: props.clearinghouses[0].id,
        settlementins: "",
        default: false
      }
    }
  );
}

export function SentAuthorization(state, response) {
  const {editClearingHouse, counterparty} = state;
  var message = "";
  if (response.response.code == 200) {
    message = "Counter Party sent for authorization";
  } else {
    message = response.response.message;
  }
  var button = {
    confirm: {
      loading: false
    }
  };
  return mergeDeep(
    {...state},
    {
      sentAuthorization: true,
      buttons: button,
      message: message,
      buttons: {
        confirm: {
          loading: false
        }
      }
    }
  );
}

export function SentAuthorizationUpdate(state, response) {
  const {editClearingHouse, counterparty} = state;
  var message = "";
  if (response.response.result.Code == 200) {
    message = "Counterparty successfully updated";
  } else {
    message = response.response.result.Decription;
  }
  var button = {
    confirm: {
      loading: false
    }
  };
  return mergeDeep(
    {...state},
    {
      sentAuthorization: true,
      buttons: button,
      message: message,
      buttons: {
        confirm: {
          loading: false
        }
      }
    }
  );
}

export function ResetClose(state, action) {
  action.onClickClose();
  return mergeDeep(
    {...state},
    {
      counterparty: {
        CounterPartyId: 0,
        CounterPartyName: "",
        CounterPartyLimit: 0,
        CounterPartyStatus: "",
        CounterPartyEmail: "",
        CustodianEntityId: 0
      },
      fields: {
        readonly: {},
        errors: {}
      },
      buttons: {
        confirm: {
          loading: false
        }
      },
      clearinghouse: {
        code: 0,
        name: "",
        clearinghouse: 0,
        settlementins: "",
        default: false
      },
      clearingHouses: [],
      custodianEntity: [],
      editClearingHouse: false,
      editClearingHouseId: false,
      saveEditClearingHouseId: 0,
      saveEditClearingHouseCode: 0,
      conf: false,
      errors: {
        title: false,
        limit: false,
        code: false,
        name: false,
        clearinghouse: false,
        settlementins: false
      },
      sentAuthorization: false,
      message: ""
    }
  );
}

export function closeClearingHouse(state) {
  const {editClearingHouse} = state;
  return mergeDeep(
    {...state},
    {
      editClearingHouse: false,
      editClearingHouseId: false,
      clearinghouse: {
        code: 0,
        name: "",
        clearinghouse: 0,
        settlementins: "",
        default: false
      }
    }
  );
}

export function GetCustodianEntity(state, action) {
  var id = 0;
  if (state.custodianEntityId == 0) {
    if (action.response.custodianEntity.length > 0) {
      id = action.response.custodianEntity[0].id;
    }
  } else {
    id = state.custodianEntityId;
  }
  return mergeDeep(
    {...state},
    {
      counterparty: {...state.counterparty, CustodianEntityId: id},
      custodianEntity: action.response.custodianEntity,
      custodianEntityId: id
    }
  );
}

export function SetCounterParty(state, action) {
  return mergeDeep(
    {...state},
    {
      counterparty: action.response.counterPartyOut,
      custodianEntityId: state.custodianEntityId == 0 ? action.response.counterPartyOut.CustodianEntityId : state.custodianEntityId
    }
  );
}

export function OpenCustodianEntity(state, action) {
  return mergeDeep(
    {...state},
    {
      isEditCustodianEntity: false,
      openCustodianEntity: true
    }
  );
}

function EditCustodianEntity(state, action) {
  return mergeDeep(
    {...state},
    {
      isEditCustodianEntity: true,
      openCustodianEntity: true
    }
  );
}

export function CloseCustodianEntity(state) {
  return mergeDeep(
    {...state},
    {
      openCustodianEntity: false
    }
  );
}

export function RechargeCustodianEntity(state, action) {
  return mergeDeep(
    {...state},
    {
      custodianEntity: action.response.custodianEntity,
      custodianEntityId: action.id
    }
  );
}

export function DefineCustodianEntityId(state, action) {
  return mergeDeep(
    {...state},
    {
      custodianEntityId: action.id
    }
  );
}
